import { AIR_TRACKING_URL, TRACKING_URL } from "constants/common.constants";
import { PRODUCTS } from "constants/products.constants";

type TrackingCard = {
  id: string;
  action: string;
  /** The `shipment-type` the tracking page opens on. */
  shipmentType: "sea" | "air";
  title: string;
  text: string;
  placeholder: string;
};

const CARDS: TrackingCard[] = [
  {
    id: "container-tracking",
    action: TRACKING_URL,
    shipmentType: "sea",
    title: "Container Tracking",
    text: "Real-time container status across 180+ carriers, with AIS vessel positions and predicted ETA at every transshipment port.",
    placeholder: "Container, booking or bill of lading",
  },
  {
    id: "air-tracking",
    action: AIR_TRACKING_URL,
    shipmentType: "air",
    title: "Air Tracking",
    text: "Air waybill milestones from booking to delivery, with flight-level departures, arrivals and piece-count confirmation.",
    placeholder: "Air waybill number",
  },
];

/** The same cube the Dashboard shows for the product, so the two never disagree. */
const cubeOf = (id: string): string | undefined => PRODUCTS.find((product) => product.id === id)?.cube;

/**
 * Plain GET forms handing the number to the public tracking page in a new tab,
 * as the design has it: that page already reads `number` and `shipment-type`,
 * and the full tool — map, events, follow — lives there, not in the cabinet.
 */
export const TrackingPanel = () => (
  <div className="pcx">
    <div className="pcx__top">
      <div>
        <div className="pcx__h">Tracking</div>
        <p className="pcx__sub">Track a single shipment by number, or open the full tracking page.</p>
      </div>
    </div>

    <div className="pc-trk">
      {CARDS.map((card) => (
        <form key={card.id} className="pc-trk__card" action={card.action} method="get" target="_blank">
          <input type="hidden" name="shipment-type" value={card.shipmentType} />
          <img className="pc-trk__cube" src={cubeOf(card.id)} alt="" width={56} height={56} />
          <div className="pc-trk__h">{card.title}</div>
          <p className="pc-trk__t">{card.text}</p>
          <div className="pc-trk__form">
            <input
              className="pcinp"
              type="text"
              name="number"
              placeholder={card.placeholder}
              aria-label={card.placeholder}
              autoComplete="off"
              spellCheck={false}
            />
            <button type="submit" className="pcbtn pcbtn--main">
              Track
            </button>
          </div>
        </form>
      ))}
    </div>
  </div>
);
